// IMPORTANT: Disable console in production FIRST, before any other code runs
// This prevents console logs, warnings, and errors from being visible to users in production
import { disableConsoleInProduction } from './utils/consoleDisabler.js'
disableConsoleInProduction();

import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, useNavigate, Navigate } from 'react-router-dom'
import './index.css'
import App from './App.jsx'
import { initializeSentry } from './utils/sentry.js'

// Initialize Sentry for error tracking
initializeSentry();

// Initialize mobile app features if running on native platform
// Use dynamic import to avoid build errors in web environments
(async () => {
  try {
    const { initializeMobileApp } = await import('./utils/mobile.js');
    await initializeMobileApp();
  } catch (error) {
    // Silently fail in web builds where Capacitor isn't available
    if (import.meta.env.DEV) {
      console.debug('Mobile app initialization skipped (web build):', error.message);
    }
  }
})();

function OAuthReturn() {
  const navigate = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => navigate('/wallet', { replace: true }), 300);
    return () => clearTimeout(t);
  }, [navigate]);
  return (
    <div style={{ padding: 24, textAlign: 'center' }}>Resuming your secure connection...</div>
  );
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/oauth-return" element={<OAuthReturn />} />
        <Route path="/*" element={<App />} />
        {/* Fallback for direct root hits when Router inside App might not be mounted yet */}
        <Route path="/" element={<Navigate to="/wallet" replace />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
